import { Component, OnInit } from "@angular/core";
import { LocaleService } from "src/app/shared/services/locale.service";
import { Observable } from "rxjs";

@Component({
  selector: "app-privacy",
  templateUrl: "./privacy.component.html",
  styleUrls: ["./privacy.component.scss"],
})
export class PrivacyComponent implements OnInit {
  locale: Observable<string | null>;
  constructor(private localeService: LocaleService) {}

  ngOnInit(): void {
    this.locale = this.localeService.getCurrentLocale();
  }
}
